module.exports = __webpack_public_path__ + "static/media/risk-green.6e5600ef.svg";